import React from 'react';
import { useTrusteesFormPresenter } from './TrusteesForm.presenter';

import {
  MESS_BANKS_NOTIFICATION,
  MESS_SOME_BANKS_NOTIFICATION,
} from 'utils/validationUtils/messages';
import { InputMask } from 'utils/inputMask';
import { VOID_FUNCTION } from 'constants';
import { NAMES, TRUSTEES_FORM_LABELS } from './TrusteesForm.constants';
import { KEY_COMPONENTS } from 'components/modules/MainAnketa/MainAnketa.constants';

import { ReactTooltipStyled } from '../../../MainAnketa.styles';
import { FormSubheader, GridRowSubHeader } from '../../AnketaForm.styles';
import * as S from './TrusteesForm.styles';

export const TrusteesForm = ({
  validate,
  errors,
  spouseForm,
  isContentHidden = false,
  disabled = false,
  setFocusAt,
  onChangeSpouse,
  onChange = VOID_FUNCTION,
}) => {
  const presenter = useTrusteesFormPresenter({
    validate,
    errors,
    spouseForm,
    isContentHidden,
    setFocusAt,
    onChangeSpouse,
    onChange,
  });

  const { trusteesFormValues, spouseFormValues } = presenter;

  return (
    <>
      <GridRowSubHeader>
        <FormSubheader>{spouseForm ? 'Данные о супруге' : 'Доверенное лицо'}</FormSubheader>
      </GridRowSubHeader>
      <S.FormGridRow>
        {trusteesFormValues && !spouseForm && (
          <>
            <S.TrusteeFio
              id={`${KEY_COMPONENTS.TRUSTEES}_${presenter.trusteeId}_${NAMES.TRUSTEES_FULL_NAME}`}
              tabIndex={'54'}
              defaultValue={trusteesFormValues[NAMES.TRUSTEES_FULL_NAME]}
              valueGender={trusteesFormValues[NAMES.TRUSTEES_GENDER]}
              error={presenter.getError(
                `${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_FULL_NAME}`
              )}
              mask={InputMask.RUS_NAME}
              required
              disabled={disabled}
              dataTest="confidant"
              changeHandler={presenter.changeHandlerTrusteeFio}
              onBlur={() =>
                presenter.validation(`${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_FULL_NAME}`)
              }
            />
            <>
              <S.TrusteePhone
                id={`${KEY_COMPONENTS.TRUSTEES}_${presenter.trusteeId}_${NAMES.TRUSTEES_PHONE}`}
                tabIndex="56"
                label={TRUSTEES_FORM_LABELS[NAMES.TRUSTEES_PHONE]}
                name={NAMES.TRUSTEES_PHONE}
                defaultValue={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : trusteesFormValues.phone
                }
                val={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : trusteesFormValues.phone
                }
                error={presenter.getError(`${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_PHONE}`)}
                mask={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : InputMask.CELLPHONE_PRIVATE_NEW
                }
                required
                disabled={disabled || isContentHidden}
                dataTest="confidantPone"
                onChange={presenter.changeHandlerTrusteePhone}
                onBlur={() =>
                  presenter.validation(`${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_PHONE}`)
                }
              />
              <S.TrusteePhoneInfo showPhoneInfo={true}>
                <span>
                  {presenter.showPhoneInfo &&
                    !presenter.getError(`${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_PHONE}`) &&
                    MESS_BANKS_NOTIFICATION}
                </span>

                {presenter.showPhoneInfo &&
                  !presenter.getError(`${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.TRUSTEES_PHONE}`) && (
                    <>
                      <S.StyledInfoSvg data-tip="" data-for="trusteePhoneInfo" />
                      <ReactTooltipStyled id="trusteePhoneInfo" place="right">
                        По требованию банков телефон контактного лица
                        <br />
                        не должен совпадать с личным мобильным
                      </ReactTooltipStyled>
                    </>
                  )}
              </S.TrusteePhoneInfo>
            </>
          </>
        )}

        {spouseFormValues && spouseForm && (
          <>
            <S.SpouseFio
              id={`${KEY_COMPONENTS.SPOUSE}_${NAMES.SPOUSE_FULL_NAME}`}
              tabIndex={'42'}
              valueGender={spouseFormValues[NAMES.SPOUSE_GENDER]}
              defaultValue={spouseFormValues[NAMES.SPOUSE_FULL_NAME]}
              error={presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_FULL_NAME}`)}
              mask={InputMask.RUS_NAME}
              required
              disabled={disabled}
              changeHandler={presenter.changeHandlerSpouseFio}
              onBlur={() =>
                presenter.validation(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_FULL_NAME}`)
              }
            />
            <>
              <S.SpouseBirthday
                id={`${KEY_COMPONENTS.SPOUSE}_${NAMES.SPOUSE_BIRTHDAY_DATE}`}
                tabIndex="43"
                label={TRUSTEES_FORM_LABELS[NAMES.SPOUSE_BIRTHDAY_DATE]}
                name={NAMES.SPOUSE_BIRTHDAY_DATE}
                defaultValue={
                  isContentHidden
                    ? InputMask.DATE_BEFORE_TODAY_CUSTOMER[0].hidden
                    : spouseFormValues[NAMES.SPOUSE_BIRTHDAY_DATE]
                }
                val={
                  isContentHidden
                    ? InputMask.DATE_BEFORE_TODAY_CUSTOMER[0].hidden
                    : spouseFormValues[NAMES.SPOUSE_BIRTHDAY_DATE]
                }
                error={presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_BIRTHDAY_DATE}`)}
                mask={
                  isContentHidden
                    ? InputMask.DATE_BEFORE_TODAY_CUSTOMER[0].hidden
                    : InputMask.DATE_BEFORE_TODAY_CUSTOMER
                }
                unmask={!isContentHidden}
                disabled={disabled || isContentHidden}
                onChange={presenter.changeHandlerSpouseBirthDate}
                onComplete={presenter.changeHandlerBirthDateComplete}
                onBlur={() =>
                  presenter.validation(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_BIRTHDAY_DATE}`)
                }
              />
              <S.SpouseBirthdayInfo showBirthdayInfo={true}>
                <span>
                  {presenter.showBirthdayInfo &&
                    !presenter.getError(
                      `${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.SPOUSE_BIRTHDAY_DATE}`
                    ) &&
                    !presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_BIRTHDAY_DATE}`) &&
                    MESS_SOME_BANKS_NOTIFICATION}
                </span>

                {presenter.showBirthdayInfo &&
                  !presenter.getError(
                    `${KEY_COMPONENTS.TRUSTEES}[0].${NAMES.SPOUSE_BIRTHDAY_DATE}`
                  ) && (
                    <>
                      <S.StyledInfoSvg data-tip="" data-for="trusteeBirthdayInfo" />
                      <ReactTooltipStyled id="trusteeBirthdayInfo" place="right">
                        Дата рождения доверенного лица
                        <br />
                        необходима для рассмотрения заявки
                      </ReactTooltipStyled>
                    </>
                  )}
              </S.SpouseBirthdayInfo>
            </>
            <>
              <S.SpousePhone
                id={`${KEY_COMPONENTS.SPOUSE}_${NAMES.SPOUSE_PHONE}`}
                tabIndex="46"
                label={TRUSTEES_FORM_LABELS[NAMES.SPOUSE_PHONE]}
                name={NAMES.SPOUSE_PHONE}
                defaultValue={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : spouseFormValues[NAMES.SPOUSE_PHONE]
                }
                val={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : spouseFormValues[NAMES.SPOUSE_PHONE]
                }
                error={presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_PHONE}`)}
                mask={
                  isContentHidden
                    ? InputMask.CELLPHONE_PRIVATE_NEW[0].hidden
                    : InputMask.CELLPHONE_PRIVATE_NEW
                }
                required
                disabled={disabled || isContentHidden}
                onChange={presenter.changeHandlerSpousePhone}
                onBlur={() =>
                  presenter.validation(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_PHONE}`)
                }
              />
              <S.SpousePhoneInfo showPhoneInfo={presenter.showPhoneInfo}>
                <span>
                  {presenter.showPhoneInfo &&
                    !presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_PHONE}`) &&
                    MESS_BANKS_NOTIFICATION}
                </span>

                {presenter.showPhoneInfo &&
                  !presenter.getError(`${KEY_COMPONENTS.SPOUSE}.${NAMES.SPOUSE_PHONE}`) && (
                    <>
                      <S.StyledInfoSvg data-tip="" data-for="spousePhoneInfo" />
                      <ReactTooltipStyled id="spousePhoneInfo" place="right">
                        По требованию банков телефон контактного лица
                        <br />
                        не должен совпадать с личным мобильным
                      </ReactTooltipStyled>
                    </>
                  )}
              </S.SpousePhoneInfo>
            </>
          </>
        )}
      </S.FormGridRow>
    </>
  );
};
